// extracted by mini-css-extract-plugin
export default {"container":"qrEop","title":"H52ED","titleThin":"sv72U","titleAbsolute":"aWrs-","text":"q8xFP","cardsBlock":"ytuiQ","cardsContainer":"gjJSl","skeleton-progress":"knaiD"};